import React from 'react';
import PropTypes from 'prop-types';

import { mergeClasses } from '@utils';

import Badge from './assets/Unisport_FC_Badge.png';

export default function MembershipHeading({
  as: Component,
  className,
  children,
  ...restProps
}) {
  return (
    <div className="flex items-start gap-4">
      <img
        src={Badge}
        alt="Unisport FC Badge"
        className="h-14 w-14"
        loading="lazy"
      />
      <Component
        className={mergeClasses(
          'm-0 p-0 text-[32px] font-black uppercase leading-none text-black',
          className
        )}
        {...restProps}
      >
        {children}
      </Component>
    </div>
  );
}

MembershipHeading.propTypes = {
  as: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4']),
  className: PropTypes.string,
  children: PropTypes.node.isRequired
};

MembershipHeading.defaultProps = {
  as: 'h2',
  className: ''
};
